/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import MuiTabs from '@material-ui/core/Tabs';
import theme from 'utils/theme';
import './Tabs.css';

function Tabs(props) {
    return (
        <MuiThemeProvider theme={theme}>
            <MuiTabs
                {...props}
                indicatorColor="primary"
                textColor="primary"
                classes={{
                    root: 'filter-tabs__tabs-root',
                    indicator: 'filter-tabs__tab-indicator',
                }}
            />
        </MuiThemeProvider>
    );
}
Tabs.muiName = MuiTabs.muiName;

export default Tabs;
